import { maxBufferedEvents, parameters } from './constants'

const userEvents = {
  sessionId: null,
  events: [],
  path: '',
  eventData: [],
  sendEventsIntervalId: null,
  interval: 0,
  cb: null,
  instance: null,
  changePath: function (path) {
    this.path = path
  },
  sendEvents: function () {
    if (this.eventData.length === 0) return

    const batch = this.eventData
    this.eventData = []

    Promise.resolve(this.cb({ events: batch })).catch(() => {
      this.eventData = [...batch, ...this.eventData].slice(-maxBufferedEvents)
    })
  },
  startSendingEvents: function () {
    this.sendEventsIntervalId = setInterval(() => {
      this.sendEvents()
    }, this.interval)
  },
  handleEvent: function (e) {
    const eventInfo = {
      timestamp: Date.now(),
      sessionId: this.sessionId,
      page: this.path,
      type: e.type,
      parameters: {
        ...parameters[e?.type]?.(e),
      },
    }
    this.eventData.push(eventInfo)
  },
  setupListeners: function () {
    this.events.forEach(event => {
      window.addEventListener(event, this.handleEvent.bind(this))
    })
  },
  destroy: function () {
    clearInterval(this.sendEventsIntervalId)
    this.events.forEach(event => {
      window.removeEventListener(event, this.handleEvent.bind(this))
    })
  },
  init: function ({ events, cb, interval = 20000, sessionId = Math.random().toString(36).substring(2, 15) }) {
    if (!this.instance) {
      this.events = events
      this.sessionId = sessionId
      this.cb = cb
      this.interval = interval
      this.instance = this
      this.setupListeners()
      this.startSendingEvents()
    }
    return this
  },
}

export default userEvents
